import { useEffect } from 'react';
import { useDeepCompareMemoize } from './useDeepCompareMemoize';

export function useDeepCompareEffect(
  callback: () => void,
  dependencies: unknown[]
) {
  useEffect(callback, useDeepCompareMemoize(dependencies));
}
